<template>
  <div class="EditContainer mb20">
    <div
      style="display: flex;justify-content: flex-start;align-items: center;margin-bottom: 20px;"
    >
      <div class="mr8">名称:</div>
      <a-input
        v-model:value="topbarParams.title"
        placeholder=""
        :maxlength="255"
        style="width: 300px"
      />
    </div>
    <div class="w200 mb20 colorPickerPer">
      <div class="mb4"><span class="red">*</span>背景色：</div>
      <colorPicker
        v-if="!notDefaultLang"
        format="hex6"
        placement="bottom-start"
        v-model:pureColor="topbarParams.backCol"
      ></colorPicker>
      <div
        class="colorBlock"
        :style="`background: ${topbarParams.backCol || '#000'};`"
        v-else
      ></div>
      <a-input
        :disabled="notDefaultLang"
        v-model:value="topbarParams.backCol"
        class="w100"
        placeholder="请输入色值"
      />
    </div>
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>状态：</div>
      <a-radio-group
        :disabled="
          notDefaultLang || [14, 15, 16].includes(activePeopleType - 0)
        "
        :options="statusOptions"
        @change="changeStatus"
        v-model:value="topbarParams.status"
      />
    </div>
    <!-- <div class="w500 mb20">
      <div class="mb4"><span class="red">*</span>样式：</div>
      <a-radio-group
        :disabled="notDefaultLang"
        :options="styleOptions"
        v-model:value="topbarParams.topbarStyle"
      />
    </div> -->
    <div class="w800 mb30">
      <div class="mb10"><span class="red">*</span>子级topBar的切换时间：</div>
      <div class="df">
        <div class="lh30">0s</div>
        <div class="w300">
          <a-slider
            :disabled="notDefaultLang"
            v-model:value="topbarParams.upDownTime"
            :min="1"
            :max="20"
          />
        </div>
        <div class="lh30">20s</div>
      </div>
    </div>
    <div class="w800 mb30">
      <div class="mb10">
        <span class="red">*</span>TopBar长度超出一屏时的滚动展示时间：
      </div>
      <div class="df">
        <div class="lh30">0s</div>
        <div class="w300">
          <a-slider
            :disabled="notDefaultLang"
            v-model:value="topbarParams.leftRightTime"
            :min="1"
            :max="20"
          />
        </div>
        <div class="lh30">20s</div>
      </div>
    </div>
    <div class="w200 mb20" v-if="route.query.terminalId - 0 === 1">
      <div class="mb4"><span class="red">*</span>是否吸顶：</div>
      <a-radio-group
        :options="ceilingOptions"
        v-model:value="topbarParams.ceiling"
        :disabled="notDefaultLang"
      />
    </div>
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>不展示的路由：</div>
      <a-input
        class="w300"
        :disabled="notDefaultLang"
        v-model:value="topbarParams.filterUrl"
        placeholder="多个路由以;分割"
      />
    </div>
  </div>
  <div class="EditContainer">
    <draggable
      class="df"
      style="flex-wrap: wrap;"
      v-model="topbarParams.topbarItemDTOList"
      @start="drag = true"
      @end="drag = false"
      item-key="index"
    >
      <template #item="{ element, index }">
        <div style="display: flex;">
          <div
            class="element"
            v-if="
              element.addButton &&
                topbarParams.topbarItemDTOList.filter(v => !v.addButton)
                  .length < 5
            "
          >
            <div class="addTopBarItem" @click.stop="addTopBarItem">
              + 添加
            </div>
          </div>

          <div class="element" v-if="!element?.addButton">
            <div>
              <div class="title oh pr">
                <b>Topbar{{ index + 1 }}</b>
                <a-popconfirm
                  title="是否确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="() => removeTopbar(index)"
                  @cancel="() => {}"
                >
                  <div
                    class="pa t2 r0 cp"
                    v-if="!element?.addButton && index !== 0"
                  >
                    <delete-outlined />
                  </div>
                </a-popconfirm>
              </div>
              <div class="mb20">
                <div class="mb4">
                  <span class="red">*</span>文案：
                  <span v-if="route?.query?.terminalId - 0 === 1" class="red"
                    >（topBar禁止换行）</span
                  >
                </div>
                <div
                  style="background: #ffffff;"
                  v-if="route?.query?.terminalId - 0 === 1"
                >
                  <template v-for="(lang, langIndex) in element.langs">
                    <quillEditor
                      v-model:value="lang.text"
                      v-if="lang.langCode === langCode"
                      style="height: 100px; width: 380px;"
                      :options="editorOption"
                      :key="langIndex"
                    />
                  </template>
                </div>
                <div style="background: #ffffff;" v-else>
                  <template v-for="(lang, langIndex) in element.langs">
                    <a-textarea
                      v-model:value="lang.text"
                      v-if="lang.langCode === langCode"
                      placeholder="请输入"
                      :maxlength="65"
                      style="width: 380px;"
                      showCount
                      :key="langIndex"
                    />
                  </template>
                </div>
              </div>
              <div class="mb20" v-if="route?.query?.terminalId - 0 !== 1">
                <div class="mb4"><span class="red">*</span>文案颜色：</div>
                <div class="df">
                  <div class="pt4 pickColor" v-if="!notDefaultLang">
                    <colorPicker
                      format="hex6"
                      v-model:pureColor="element.textColor"
                    />
                  </div>
                  <div
                    class="colorBlock"
                    :style="`background: ${element.textColor};`"
                    v-if="notDefaultLang"
                  />
                  <div>
                    <a-input
                      v-model:value="element.textColor"
                      class="w100"
                      placeholder="请输入色值"
                      :disabled="notDefaultLang"
                    />
                  </div>
                </div>
              </div>
              <div class="mb20">
                <div class="mb4">链接：</div>
                <div style="background: #ffffff;">
                  <a-input
                    :disabled="notDefaultLang"
                    v-model:value="element.link"
                    placeholder="请输入"
                  />
                </div>
              </div>
              <div class="mb20">
                <div class="mb4">
                  <a-radio-group
                    :disabled="notDefaultLang"
                    @change="e => countChange(e, element)"
                    v-model:value="element.countdown"
                    name="radioGroup"
                  >
                    <a-radio :value="0">无倒计时</a-radio>
                    <a-radio :value="1">活动倒计时</a-radio>
                    <a-radio :value="2">预热倒计时</a-radio>
                  </a-radio-group>
                </div>
              </div>
              <template v-if="element?.countdown - 0 !== 0">
                <div class="mb20" v-if="element?.countdown - 0 === 2">
                  <div class="mb4">
                    <span class="red">*</span>预热开始时间（GMT+1）：
                  </div>
                  <a-date-picker
                    :disabled="notDefaultLang"
                    placeholder="请选择"
                    v-model:value="element.preheatStartTime"
                    :format="dateFormat"
                    :valueFormat="dateFormat"
                    show-time
                  />
                </div>
                <div class="mb20">
                  <div class="mb4">
                    <span class="red">*</span>活动起止时间（GMT+1）：
                  </div>
                  <div style="background: #ffffff;">
                    <a-range-picker
                      show-time
                      :placeholder="['开始时间', '结束时间']"
                      :disabled="!element.countdown || notDefaultLang"
                      v-model:value="element.times"
                      @change="
                        (dates, dateString) =>
                          changeDate(dateString, element, dates)
                      "
                      :format="dateFormat"
                    />
                  </div>
                </div>
                <div class="mb20">
                  <div class="mb4"><span class="red">*</span>倒计时颜色：</div>
                  <div class="df">
                    <div class="pt4 pickColor">
                      <colorPicker
                        v-if="element?.countdown && !notDefaultLang"
                        format="hex6"
                        v-model:pureColor="element.color"
                      ></colorPicker>
                    </div>
                    <div
                      class="colorBlock"
                      :style="`background: ${element.color};`"
                      v-if="!element?.countdown || notDefaultLang"
                    ></div>
                    <div>
                      <a-input
                        v-model:value="element.color"
                        class="w100"
                        :disabled="!element?.countdown || notDefaultLang"
                        placeholder="请输入色值"
                      />
                    </div>
                  </div>
                </div>
                <div class="mb20" v-if="element?.countdown - 0 === 2">
                  <div>
                    距离倒计时开始对应文案
                    <span v-if="route?.query?.terminalId - 0 !== 1"
                      >(比如“开始于”)</span
                    >
                  </div>
                  <p v-if="route?.query?.terminalId - 0 === 1">
                    (比如“开始于”，<span style="color: red;">禁止换行</span>)
                  </p>
                  <div
                    class="cc"
                    style="background: #ffffff;"
                    v-if="route?.query?.terminalId - 0 === 1"
                  >
                    <quillEditor
                      v-model:value="
                        element.langs[
                          element.langs.findIndex(v => v.langCode === langCode)
                        ].startText
                      "
                      style="height: 100px; width: 380px;"
                      :options="editorOption"
                    />
                  </div>
                  <div style="background: #ffffff;" v-else>
                    <a-textarea
                      v-model:value="
                        element.langs[
                          element.langs.findIndex(v => v.langCode === langCode)
                        ].startText
                      "
                      placeholder="请输入"
                      :maxlength="55"
                      style="width: 380px;"
                      showCount
                    />
                  </div>
                </div>
                <div class="mb20">
                  <div>
                    距离倒计时结束对应文案
                    <span v-if="route?.query?.terminalId - 0 !== 1"
                      >(比如“结束于”)</span
                    >
                  </div>
                  <p v-if="route?.query?.terminalId - 0 === 1">
                    (比如“结束于”，<span style="color: red;">禁止换行</span>)
                  </p>
                  <div
                    class="cc"
                    style="background: #ffffff;"
                    v-if="route?.query?.terminalId - 0 === 1"
                  >
                    <quillEditor
                      v-model:value="
                        element.langs[
                          element.langs.findIndex(v => v.langCode === langCode)
                        ].endText
                      "
                      style="height: 100px; width: 380px;"
                      :options="editorOption"
                    />
                  </div>
                  <div style="background: #ffffff;" v-else>
                    <a-textarea
                      v-model:value="
                        element.langs[
                          element.langs.findIndex(v => v.langCode === langCode)
                        ].endText
                      "
                      placeholder="请输入"
                      :maxlength="55"
                      style="width: 380px;"
                      showCount
                    />
                  </div>
                </div>
                <div class="mb20">
                  <div class="mb4">
                    <span class="red">*</span>是否展示：
                    <a-tooltip>
                      <template #title>活动结束后是否展示文案</template>
                      <QuestionCircleOutlined />
                    </a-tooltip>
                  </div>
                  <div>
                    <a-radio-group
                      v-model:value="element.isShow"
                      :disabled="!element?.countdown || notDefaultLang"
                    >
                      <a-radio :value="true">是</a-radio>
                      <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>
<script>
import { ColorPicker } from '@cupshe/vue3-colorpicker'
import { toRefs, reactive, inject, computed } from 'vue'
import draggable from 'vuedraggable'
import { quillEditor } from 'vue3-quill'
import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    ColorPicker,
    draggable,
    quillEditor,
    DeleteOutlined,
    QuestionCircleOutlined
  },
  setup() {
    const injectState = inject('initState')
    console.log('injectState', injectState)
    const notDefaultLang = computed(
      () => injectState.langCode !== injectState.defaultLanguageCode
    )
    const state = reactive({
      changeDate: (dateString, item) => {
        console.log('dateString ', dateString)
        item.startTime = dateString[0]
        item.endTime = dateString[1]
      },
      countChange: (e, element) => {
        if (!e.target.checked) {
          element.times = []
          element.startTime = null
          element.endTime = null
        }
      },
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      drag: false
    })

    return {
      ...toRefs(injectState),
      ...toRefs(state),
      notDefaultLang,
      editorOption: {
        placeholder: '输入',
        autofocus: false,
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [{ size: ['small', false, 'large', 'huge', '12px'] }],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      },
      statusOptions: [
        {
          label: '禁用',
          value: 0
        },
        {
          label: '启用',
          value: 1
        }
      ],
      styleOptions: [
        {
          label: '同时展示一个',
          value: 0
        }
        // ,{
        //   label: '同时展示多个',
        //   value: 1
        // }
      ],
      ceilingOptions: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.checkTabs {
  width: 216px;
  height: 46px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
}

.checkTab {
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
}

.checkTab.check {
  background: #ffffff;
}

.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.colorBlock {
  width: 50px;
  height: 24px;
  margin-right: 10px;
  display: block;
  float: left;
  margin-top: 4px;
}

.addTopBarItem {
  cursor: pointer;
}
.element {
  width: 400px;
  background: #f8f8f8;
  margin: 10px;
  padding: 10px;
}

.element .title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

.addTopBarItem {
  width: 300px;
  height: 580px;
  text-align: center;
  line-height: 580px;
}
</style>
<style>
.colorPickerPer .vc-lightness-slider,
.colorPickerPer .vc-display {
  display: none !important;
}
</style>
